// EXTRACT: candidate for libs/ui — these shapes are app-agnostic and could move
// into a shared "submissions" model once the abstraction stabilizes.

export type FeedbackResponseStatus = "in_review" | "reviewed" | "dismissed";

/**
 * Row shape consumed by the list page. Mirrors the future API DTO closely
 * (feedback_response::Model fields minus internal-only token fields).
 */
export interface FeedbackResponseRow {
  id: string;
  feedback_collection_id: string;
  status: FeedbackResponseStatus;
  user_display_name: string;
  intended_group: string;
  agency: string;
  time_created: string;
  time_updated: string;
  time_submitted: string;
  time_modification_token_exp: string;
  surveyjs_data: Record<string, unknown>;
}

/**
 * Local fixture shape for a feedback collection (survey definition).
 * Mirrors the future API DTO. `surveyjs_configuration` is the raw SurveyJS
 * JSON consumed by `survey-core` Model.
 */
export interface FeedbackCollectionFixture {
  id: string;
  name: string;
  surveyjs_configuration: Record<string, unknown>;
}

export interface FeedbackFilters {
  collectionId: string | null;
  submitStartDate: string | null;
  submitEndDate: string | null;
}

export const EMPTY_FEEDBACK_FILTERS: FeedbackFilters = {
  collectionId: null,
  submitStartDate: null,
  submitEndDate: null,
};

export const countActiveFilters = (filters: FeedbackFilters): number => {
  let count = 0;
  if (filters.collectionId) count += 1;
  if (filters.submitStartDate) count += 1;
  if (filters.submitEndDate) count += 1;
  return count;
};

export interface FeedbackResponsesQuery {
  search?: string;
  filters: FeedbackFilters;
  page: number;
  pageSize: number;
}

export interface FeedbackResponsesResult {
  rows: FeedbackResponseRow[];
  total: number;
  isLoading: boolean;
}

export type FeedbackListViewMode = "default" | "map" | "list";
